import { render, staticRenderFns } from "./PrescriptionTable.vue?vue&type=template&id=705cb98c&scoped=true"
import script from "./PrescriptionTable.vue?vue&type=script&lang=js"
export * from "./PrescriptionTable.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionTable.vue?vue&type=style&index=0&id=705cb98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cb98c",
  null
  
)

export default component.exports